import GenericModal from "../../../../utils/GenericModal";
import {InputComponent} from "../../../../utils/FormComponents";
import {IoWarning} from "react-icons/io5";
import useModifyScalewayKeyModal from "./useModifyScalewayKeyModal";


export default function ModifyScalewayKeyModal() {
    const [
        {apiKey, errors},
        {handleInputChange, handleKeySave, toggleMe},
    ] = useModifyScalewayKeyModal();
    return (
        <GenericModal
            className="w-3/4 lg:w-2/5 xl:w-1/2 2xl:w-1/4 text-base text-black rounded-lg"
            showCloseButton={true}
            exitClick={false}
            toggleMe={toggleMe}
        >
            <div className="font-semibold w-full text-left px-4 py-3 border-b text-sm flex items-end gap-1">
                <IoWarning className="text-red-400 w-5 h-5"/>Mettre à jour la clé d'API
            </div>
            <div className="pt-8 pr-8 pl-8 text-justify">
                <p><b>ATTENTION ! </b>Vous êtes sur le point de changer <b>la clé d'API</b> qui nous relie à Scaleway.</p>
                <p>
                    Cela entraînera la <b>suppression de l'ancienne clé</b> et peut entrainer des erreurs si une clé incorrecte est insérée. Êtes-vous sûr de
                    vouloir continuer ?
                </p>
            </div>
            <form onSubmit={handleKeySave} noValidate>
                <div className="flex flex-col gap-4 p-8">
                    <InputComponent
                        label="Clé d'API"
                        name="name"
                        value={apiKey}
                        onChange={handleInputChange}
                        error={errors}
                    />
                </div>
                <div className="flex w-full justify-end gap-4 py-2 border-t px-4">
                    <button
                        onClick={toggleMe}
                        className="rounded border bg-white text-black text-sm font-light py-1 px-2"
                    >Annuler
                    </button>
                    <button
                        type="submit"
                        className="rounded bg-gray-600 hover:bg-gray-700 hover:shadow text-white text-sm py-1 px-2 transform duration-300"
                    >Valider
                    </button>
                </div>
            </form>
        </GenericModal>
    );
}
